import { useHead } from '@unhead/vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '~/stores/auth'
import { useNavigationStore } from '~/stores/navigation'

export const usePageTitle = () => {
  const route = useRoute()

  const AuthStore = useAuthStore()
  const NavigationStore = useNavigationStore()

  const currentClientInTitle = computed<string>(() => {
    return AuthStore.user?.clientName ?? ''
  })
  const currentService = computed<string>(() => {
    return NavigationStore.activeServiceName
      ? `${NavigationStore.activeServiceName} Service`
      : ''
  })

  useHead(() => {
    const leaf = route.matched[route.matched.length - 1]
    const title = leaf?.meta?.title

    return {
      title,
      titleTemplate: (t: string | undefined) => {
        return [
          t,
          currentService.value,
          currentClientInTitle.value,
          'Berkshire Client Portal',
        ]
          .filter((substr) => !!substr)
          .join(' - ')
      },
    }
  })
}
